/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DemographicIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Demographic',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M7.939 8.1a3.9 3.9 0 1 0-3.9-3.9 3.9 3.9 0 0 0 3.9 3.9ZM17.939 8.1a3.9 3.9 0 1 0-3.9-3.9 3.9 3.9 0 0 0 3.9 3.9ZM27.939 8.1a3.9 3.9 0 1 0-3.9-3.9 3.9 3.9 0 0 0 3.9 3.9ZM28.139 10h-.4a6.136 6.136 0 0 0-4.8 1.863 6.139 6.139 0 0 0-4.8-1.863h-.4a6.136 6.136 0 0 0-4.8 1.863A6.139 6.139 0 0 0 8.139 10h-.4c-3.2 0-5.8 1.6-5.8 4.8V22a1 1 0 0 0 1 1h1l1 10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l1-10h2l1 10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l1-10h2l1 10a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1l1-10h1a1 1 0 0 0 1-1v-7.2c0-3.2-2.597-4.8-5.8-4.8Z"
    />
  </svg>`;
};
